import React from 'react';
import { Link } from 'react-router-dom';

const CardSection = ({
  imageUrl,
  imagePosition = 'left',
  title,
  desc,
  link,
  children
}) => {
  const cardContent = (
    <div>
      {/* Title */}
      <h2 className="text-xl font-display text-white mb-2">{title}</h2>
      {/* Description */}
      <p className="text-text-secondary mb-4">{desc}</p>
      {/* Children or a default link */}
      {children ? (
        children
      ) : link ? (
        <Link
          to={link}
          className="text-white hover:underline self-start"
        >
          {`View ${title}`}
        </Link>
      ) : null}
    </div>
  );

  return (
    <div
      className={`bg-[#A89B8D] rounded-lg shadow flex overflow-hidden items-center m-5`}
    >
      {/* Render Image on the left if imagePosition is 'left' */}
      {imageUrl && imagePosition === 'left' && (
        <div className="w-1/4 flex-shrink-0">
          <img
            src={imageUrl}
            alt={title}
            className="object-contain w-full h-full mx-auto"
          />
        </div>
      )}

      {/* Render Main Content */}
      <div
        className={`p-6 flex flex-col justify-between ${
          imageUrl ? 'w-3/4' : 'w-full'
        } ${imageUrl && imagePosition === 'right' ? 'order-first' : ''}`}
      >
        {cardContent}
      </div>

      {/* Render Image on the right if imagePosition is 'right' */}
      {imageUrl && imagePosition === 'right' && (
        <div className="w-1/4 flex-shrink-0">
          <img
            src={imageUrl}
            alt={title}
            className="object-contain w-full h-full mx-auto"
          />
        </div>
      )}
    </div>
  );
};

export default CardSection;